import { render, staticRenderFns } from "./WideBtn.vue?vue&type=template&id=cdd28104&scoped=true&"
import script from "./WideBtn.vue?vue&type=script&lang=js&"
export * from "./WideBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd28104",
  null
  
)

export default component.exports